module.exports = __webpack_public_path__ + "img/logo.ba9cb8f5.svg";